"use client";
import React, { useState } from "react";
import { Input, message } from "antd";
import { WhatsAppOutlined, MailOutlined } from "@ant-design/icons";
import Image from "next/image";
import { Link } from "@/navigation";
import { useCategory } from "@/context/CategoriesContext";
import FollowUs from "@/components/Social/FollowUs";
import { useTranslations } from "next-intl";

const { Search } = Input;
import { Menu, menus } from "@/lib/menu";
import { contactInfo } from "@/lib/contacts";
import { subscribeEmail } from "@/lib/api/subscribe.ts";
const Footer = () => {
	const { categories } = useCategory();
	const solutionCategory: any = categories?.edges.filter((item) => item.node.slug === "Solution") || [];

	const t = useTranslations();
	const solutionMenu: Menu[] = menus.filter((item) => item.id === 9);
	const [subscribeLoading, setSubscribeLoading] = useState(false);
	const subscribe = async (value: string) => {
		try {
			if (!value) return;
			setSubscribeLoading(true);
			await subscribeEmail({ email: value, subscribe_type: 3 });
			message.success(t("footer.subscribeSuccess"));
		} catch (e) {
			message.error(e.message);
		}
		setSubscribeLoading(false);
	};

	return (
		<footer className="py-12">
			<div className="container grid grid-cols-1 gap-8 px-4 md:grid-cols-11">
				{/* 公司信息部分 */}
				<div className="md:col-span-4">
					<div className="flex items-end">
						<Image
							src="/image/logo1.png"
							width={100}
							height={50}
							alt="JS Precision logo"
							className="object-cover"
							loading="lazy"
						></Image>
						{/*<h3 className="text-xl font-bold mb-4">LONGSHENG</h3>*/}
					</div>
					{/*Dongguan City Longsheng Hardware Technology Co., Ltd*/}
					<p className="mb-2 text-sm text-[#3c3c3c]">JS Precision Ltd.</p>
					<p className="mt-4 text-sm text-[#3c3c3c]">{t("footer.USA")}</p>
					<p>
						30 N. Gould St. Ste N<br />
						Sheridan, WY 82801, USA
					</p>
					<p className="mt-4 text-sm text-[#3c3c3c]">{t("footer.China")}</p>
					<p className="text-[#3c3c3c]">102, Building 2, No.1, South Jizhi Road, Humen Town, Dongguan City</p>
					<FollowUs textClass="#606060" />
				</div>

				{/* 服务部分 */}
				<div className="md:col-span-2">
					<h3 className="mb-4 text-base font-bold">{t("menu.service")}</h3>
					<ul className="space-y-2">
						{categories?.edges.map((item, index) => {
							return (
								item.node.slug !== "Solution" &&
								index < 5 && (
									<li key={item.node.id}>
										<Link href={"/" + item.node.slug} className="text-[#3c3c3c]">
											{item.node.translation?.name || item.node.name}
										</Link>
									</li>
								)
							);
						})}
						{solutionCategory.length > 0 &&
							solutionCategory[0].node?.children?.edges.map((item: any) => {
								return (
									<li key={item.node.id}>
										<Link href={"/" + item.node.slug} className="text-[#3c3c3c]">
											{item.node.translation?.name || item.node.name}
										</Link>
									</li>
								);
							})}
					</ul>
				</div>

				{/* 解决方案部分 */}
				<div className="md:col-span-2">
					<h3 className="mb-4 text-base font-bold">{t("menu.solutions")}</h3>
					<ul className="space-y-2">
						{solutionMenu.length > 0 &&
							solutionMenu[0].children &&
							solutionMenu[0].children.map((item) => {
								return (
									<li key={item.id}>
										<Link href={item.link} className="text-[#3c3c3c]">
											{t(item.name)}
										</Link>
									</li>
								);
							})}
					</ul>
				</div>

				{/* 联系方式和订阅部分：电话跳转 WhatsApp，邮箱打开邮件客户端 */}
				<div className="md:col-span-3">
					<h3 className="mb-4 text-base font-bold">{t("menu.contactUs")}</h3>
					<ul className="space-y-2">
						<li className="flex items-start">
							<WhatsAppOutlined className="!text-themePrimary400 mr-2 mt-1" />
							<a
								href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, "")}`}
								target="_blank"
								rel="noopener noreferrer"
								className="hover:text-themePrimary400 text-[#3c3c3c] hover:underline"
							>
								{contactInfo.whatsapp}
							</a>
						</li>
						<li className="flex items-start">
							<MailOutlined className="!text-themePrimary400 mr-2 mt-1" />
							<Link
								href={`mailto:${contactInfo.email}`}
								className="hover:text-themePrimary400 text-[#3c3c3c] hover:underline"
							>
								{contactInfo.email}
							</Link>
						</li>
					</ul>
					<h3 className="mb-2 mt-8 text-base font-bold text-[#7e7e7e]">{t("footer.SubscribeNewsletter")}</h3>
					<p className="space-y-0.5">
						<span className="block">{t("footer.DoNotMissLine1")}</span>
						<span className="block">{t("footer.DoNotMissLine2")}</span>
					</p>
					<Search
						loading={subscribeLoading}
						placeholder={t("footer.emailAddress")}
						enterButton={t("footer.Subscribe")}
						size="large"
						type="email"
						className="footer-subscribe-search mt-4"
						onSearch={(value) => subscribe(value)}
					/>
				</div>
			</div>

			<div className="mt-8 flex flex-wrap items-center justify-center border-t border-gray-700 pt-4 text-center text-black">
				{t("footer.copyright")}
				<Link href="/policy" className="ml-2 text-black underline">
					{t("menu.privacyPolicy")}
				</Link>
			</div>
		</footer>
	);
};

export default Footer;
